var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.095,
    height: 29.689,
    viewBox: "0 0 28.095 29.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-185.407 -4896.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(249.432 4900.336)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -51.62405014038086 9.059012413024902 L -62.56035232543945 1.067095518112183 L -37.74334716796875 0.2258420139551163 L -51.62405014038086 9.059012413024902 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.55747604370117 0.7876319885253906 L -61.09622955322266 1.517758369445801 L -51.60457611083984 8.45396614074707 L -39.55747604370117 0.7876319885253906 M -35.92923736572266 -0.3359375 L -51.64352798461914 9.6640625 L -64.02447509765625 0.6164426803588867 L -35.92923736572266 -0.3359375 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_4",
    "data-name": "Path 4",
    transform: "translate(219.928 4863.734) rotate(-65)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -37.74334716796875 9.102282524108887 L -62.56035232543945 8.261029243469238 L -51.62405014038086 0.2691129446029663 L -37.74334716796875 9.102282524108887 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.55747604370117 8.540493011474609 L -51.60457611083984 0.8741587400436401 L -61.09622955322266 7.810366630554199 L -39.55747604370117 8.540493011474609 M -35.92923736572266 9.6640625 L -64.02447509765625 8.711682319641113 L -51.64352798461914 -0.3359375 L -35.92923736572266 9.6640625 Z",
    stroke: "none",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0a8ad770edbb253f3ca4ac1c5eba43d1.svg";
export { ForwardRef as ReactComponent };